import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import clientActions from "../../redux/client_credential/action";
import { Form, Row, Col, Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const { getClientData } = clientActions;

const ClientCredential = () => {
  const dispatch = useDispatch();
  const { totalData } = useSelector((state) => state.clientReducer);
  const [form] = Form.useForm();
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [maskedClientSecret, setMaskedClientSecret] = useState("");
  useEffect(() => {
    dispatch(getClientData());
  }, [dispatch]);

  useEffect(() => {
    if (totalData?.client_secret && totalData?.client_key) {
      form.setFieldsValue({
        client_secret: totalData.client_secret,
        client_key: totalData.client_key,
      });
    }
  }, [totalData, form]);

  return (
    <div className="mainContain">
      <h1 className="transaction">Credential</h1>
      <div className="mt-4">
      <Form
        id="userForm"
        layout="horizontal"
        autoComplete="off"
        form={form}
        initialValues={{ client_secret: maskedClientSecret }}
      >
       <Row gutter={24}>
          <Col
            className="gutter-row"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 18 }}
            xl={{ span: 12 }}
          >
            <Form.Item
              label="client_secret"
              name="client_secret"
              className="custom-form-item"
            >
              {/* <Input disabled  style={{ color: '#776767' }}/> */}
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="client_key    "
              name="client_key"
              className="custom-form-item"
            >
              <Input.Password  />
            </Form.Item>
          </Col>
        </Row> 
      </Form>
    </div>
    </div>
  );
};

export default ClientCredential;
